
import { ServerSettingsSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { ISiteSettingsForSiteAdmin } from '../types/ISiteSettingsForSiteAdmin';

export const MobileSettingsSubspaceName: ServerSettingsSubspaceName = 'mobile';

export interface MobileSettingsSubspaceState {
  readonly isServerPage: boolean;
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly isMultiSite: boolean;
  readonly siteSettingsForSiteAdmin: ISiteSettingsForSiteAdmin;
}
